import Routes from '../../Routes';
import { AuthProvider } from '../../contexts/auth';

export default function App() {
  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  );
}
